import { getExamplesReducerData } from '../reducers/examples-reducer';
import { putDataInDevCenterDataStore } from '../../../app/store';
import { replaceSpace, replaceSpecialChars } from '../../../../src/libs/common-library';
import { enableResponseSection } from '../components/rhs-components/js/request-builder';
import { getPartnerFullName } from '../../../lhs/reducers/configuration-reducer.js';

var cc = 0;
function getExamplesDataAndStoreInDataStore(examplesData, selectedExampleKey, firstLevelKey, secondLevelKey, thirdLevelKey, processorSwitchFlag) {
    const skeletonItems = {}
    skeletonItems['firstLevelKey'] = firstLevelKey;
    skeletonItems['secondLevelKey'] = secondLevelKey;
    skeletonItems['thirdLevelKey'] = thirdLevelKey;
    skeletonItems['allExamplesData'] = examplesData;
    skeletonItems['exampleKey'] = selectedExampleKey;
    skeletonItems['exampleSummary'] = selectedExampleKey == undefined ? undefined : examplesData[selectedExampleKey]['summary'];
    if (selectedExampleKey !== undefined) {
        skeletonItems['exampleValue'] = examplesData[selectedExampleKey]['value'] == undefined ? undefined : processExampleValuesForPartner(examplesData[selectedExampleKey]['value']);
        skeletonItems['exampleResponseValue'] = examplesData[selectedExampleKey]['responseValue'] == undefined ? undefined : processExampleValuesForPartner(examplesData[selectedExampleKey]['responseValue']);
    }
    storeExamplesDataStoreContents(skeletonItems, processorSwitchFlag);
}

function processExampleValuesForPartner(exampleValue) {
    var obj = exampleValue;
    const oldBranding = "CyberSource";
    const newBranding = "Cybersource";
    const partnerFullName = getPartnerFullName().length > 0 ? getPartnerFullName() : 'Cybersource';
    Object.keys(obj).forEach((key) => {
        //Replace in key, if string
        if (typeof key === 'string') {
            if (key.trim().indexOf(newBranding) > -1 || key.trim().indexOf(oldBranding) > -1 || key.trim() === newBranding || key.trim() === oldBranding) {
                key = key.replaceAll(/Cybersource/ig, partnerFullName);
            }
        }

        //Replace in value if string
        if (typeof obj[key] === 'string') {
            var toReplace = obj[key];
            if (toReplace.trim().indexOf(newBranding) > -1 || toReplace.trim().indexOf(oldBranding) > -1) {
                obj[key] = toReplace.replaceAll(/Cybersource/ig, partnerFullName);
            }
        }

        //if still an object, call recursively
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            processExampleValuesForPartner(obj[key]);
        }
    });
    return obj;
}

function storeExamplesDataStoreContents(skeletonItems, processorSwitchFlag) {
    putDataInDevCenterDataStore({ type: 'UPDATE_ALL_EXAMPLES_DATA', allExamplesData: skeletonItems["allExamplesData"] });
    if (!processorSwitchFlag) {
        putDataInDevCenterDataStore({ type: 'UPDATE_FIRST_LEVEL_KEY', firstLevelKey: skeletonItems["firstLevelKey"] });
        putDataInDevCenterDataStore({ type: 'UPDATE_SECOND_LEVEL_KEY', secondLevelKey: skeletonItems["secondLevelKey"] });
        putDataInDevCenterDataStore({ type: 'UPDATE_THIRD_LEVEL_KEY', thirdLevelKey: skeletonItems["thirdLevelKey"] });
        putDataInDevCenterDataStore({ type: 'UPDATE_EXAMPLE_KEY', exampleKey: skeletonItems["exampleKey"] });
        putDataInDevCenterDataStore({ type: 'UPDATE_EXAMPLE_SUMMARY', exampleSummary: skeletonItems["exampleSummary"] });
    }
    putDataInDevCenterDataStore({ type: 'UPDATE_EXAMPLE_RESTRUCTURED_DATA', exampleRestructuredData: restructureExamplesData(getExamplesReducerData()) });
    putDataInDevCenterDataStore({ type: 'UPDATE_EXAMPLE_VALUE', exampleValue: JSON.stringify(skeletonItems["exampleValue"], null, 2) });
    putDataInDevCenterDataStore({ type: 'UPDATE_REQUEST_VALUE', requestValue: JSON.stringify(skeletonItems["exampleValue"], null, 2) });
    if ('exampleResponseValue' in skeletonItems) {
        if (skeletonItems['exampleResponseValue'] != undefined) {
            putDataInDevCenterDataStore({ type: 'UPDATE_RESPONSE_CONTENT', responseContent: JSON.stringify(skeletonItems['exampleResponseValue'], null, 2) });
            enableResponseSection();
        }
    }
    // putDataInDevCenterDataStore({type:'UPDATE_EXAMPLE_RESPONSE_VALUE',exampleResponseValue:skeletonItems["exampleResponseValue"]});
    putDataInDevCenterDataStore({ type: 'UPDATE_SAMPLE_CODE_ERROR', sampleCodeError: undefined });
    putDataInDevCenterDataStore({ type: 'UPDATE_SAMPLE_CODE_MESSAGE', sampleCodeError: "" });
}

function parentTagExists(parentTag, restructuredData) {
    for (var i = 0; i < restructuredData.length; i++) {
        if (restructuredData[i]['label'] == parentTag) {
            return true;
        }
    }
    return false;
}

function createParentTagIfNotExists(parentTag, examplesDataInStore, restructuredData) {
    var child = {}
    var childrenArray = [];
    var newArrayitem = {};
    if (!(parentTagExists(parentTag, restructuredData))) {
        for (var key in examplesDataInStore['allExamplesData']) {
            if ('parentTag' in examplesDataInStore['allExamplesData'][key]) {
                if (parentTag == examplesDataInStore['allExamplesData'][key]['parentTag']) {
                    child['label'] = examplesDataInStore['allExamplesData'][key]['summary'];
                    child['value'] = key;
                    if ('processor-type' in examplesDataInStore['allExamplesData'][key]) {
                        child['processorType'] = examplesDataInStore['allExamplesData'][key]['processor-type'];
                    }
                    childrenArray.push(child);
                    child = {};
                }
            }
            cc++;
        }
        newArrayitem['label'] = parentTag;
        newArrayitem['value'] = replaceSpecialChars(replaceSpace(parentTag));
        newArrayitem['children'] = childrenArray;
        restructuredData.push(newArrayitem);
    }
    return restructuredData;
}

function restructureExamplesData(examplesDataInStore) {
    var restructuredData = [];
    var item = {};
    if (examplesDataInStore != undefined) {
        if ('allExamplesData' in examplesDataInStore) {
            for (var key in examplesDataInStore['allExamplesData']) {
                item['label'] = examplesDataInStore['allExamplesData'][key]['summary'];
                item['value'] = key;
                item['processorType'] = examplesDataInStore['allExamplesData'][key]['processor-type'];
                if ('parentTag' in examplesDataInStore['allExamplesData'][key]) {
                    restructuredData = createParentTagIfNotExists(examplesDataInStore['allExamplesData'][key]['parentTag'], examplesDataInStore, restructuredData);
                }
                else {
                    restructuredData.push(item);
                }
                item = {};
            }
        }
    }
    return (restructuredData);
}

export default getExamplesDataAndStoreInDataStore;
export { storeExamplesDataStoreContents, restructureExamplesData };